import React from 'react';

class NotFound extends React.Component {
	render() {
		return (
			<h2 class="not-found">NotFound</h2>
		)
	}
}

export default NotFound;


/** WEBPACK FOOTER **
 ** ./src/components/NotFound.js
 **/